/** HTTP status codes the UI branches on (anything else is shown with the server's generic message). */
export const HTTP_STATUS = {
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  CONFLICT: 409,
} as const

/** Custom request headers the API client sets; IAM only honours `X-Tenant-Id` from a super admin. */
export const HTTP_HEADERS = {
  TENANT_ID: 'X-Tenant-Id',
  LANGUAGE_CODE: 'X-Language-Code',
} as const
